import React, { useEffect, useRef, useState } from "react";

export default function MobileMenuFab({ children }) {
  const [open, setOpen] = useState(false);
  const panelRef = useRef(null);

  useEffect(() => {
    function onKeyDown(e) {
      if (e.key === "Escape") setOpen(false);
    }
    document.addEventListener("keydown", onKeyDown);
    return () => document.removeEventListener("keydown", onKeyDown);
  }, []);

  useEffect(() => {
    function onClickOutside(e) {
      if (!open) return;
      const panel = panelRef.current;
      if (panel && !panel.contains(e.target)) setOpen(false);
    }
    document.addEventListener("mousedown", onClickOutside);
    document.addEventListener("touchstart", onClickOutside, { passive: true });
    return () => {
      document.removeEventListener("mousedown", onClickOutside);
      document.removeEventListener("touchstart", onClickOutside);
    };
  }, [open]);

  return (
    <>
      <button
        className="vh-mobile-fab"
        type="button"
        onClick={() => setOpen(true)}
        aria-label="Abrir menu"
      >
        &#9776;
      </button>

      {open ? (
        <div className="vh-mobile-sheet-backdrop" role="dialog" aria-modal="true">
          <div className="vh-mobile-sheet" ref={panelRef}>
            <div className="vh-mobile-sheet-header">
              <div className="vh-mobile-sheet-title">Menu</div>
              <button
                className="vh-mobile-sheet-close"
                type="button"
                onClick={() => setOpen(false)}
                aria-label="Fechar menu"
              >
                &#10005;
              </button>
            </div>
            <div className="vh-mobile-sheet-body">{children}</div>
          </div>
        </div>
      ) : null}
    </>
  );
}
